import React from 'react'
import { Trans } from 'gatsby-plugin-react-i18next'
import { graphql } from 'gatsby'
import { Seo } from '../components/SEO'

import MHeroVideo from '../assets/video/mobile/mobile_KV13.mp4'
import THeroVideo from '../assets/video/tablet/tablet_KV13.mp4'
import DHeroVideo from '../assets/video/desktop/desktop_KV13.mp4'
import MSplitVideo from '../assets/video/mobile/mobile_KV14.mp4'
import TSplitVideo from '../assets/video/tablet/tablet_KV14.mp4'
import DSplitVideo from '../assets/video/desktop/desktop_KV14.mp4'

import ProductsHero from '../components/ProductsHero'

import TilesSwiper2 from '../components/TilesSwiper2'

import Icon13 from '../assets/svg/Products-icon13.inline.svg'
import Icon27 from '../assets/svg/Products-icon27.inline.svg'
import Icon32 from '../assets/svg/Products-icon32.inline.svg'
import Icon33 from '../assets/svg/Products-icon33.inline.svg'
import Icon37 from '../assets/svg/Products-icon37.inline.svg'
import Icon38 from '../assets/svg/Products-icon38.inline.svg'
import Icon39 from '../assets/svg/Products-icon39.inline.svg'
import Icon40 from '../assets/svg/Products-icon40.inline.svg'
import Icon41 from '../assets/svg/Products-icon41.inline.svg'
import Icon42 from '../assets/svg/Products-icon42.inline.svg'
import Icon44 from '../assets/svg/Products-icon44.inline.svg'
import Icon45 from '../assets/svg/Products-icon45.inline.svg'
import Icon46 from '../assets/svg/Products-icon46.inline.svg'
import Icon47 from '../assets/svg/Products-icon47.inline.svg'
import Icon48 from '../assets/svg/Products-icon48.inline.svg'
import Icon49 from '../assets/svg/Products-icon49.inline.svg'

import SelectedProducts from '../components/SelectedProducts'
import SectionTechnology from '../components/SectionTechnology'
import SectionTextVideo from '../components/SectionTextVideo'
import SectionBigTile from '../components/SectionBigTile'
import SectionOrder from '../components/SectionOrder'

const SlideTiles1 = [
  {
    content: <Trans>SlideTilesContent1_1</Trans>,
    icon: <Icon37 />,
  },
  {
    content: <Trans>SlideTilesContent1_2</Trans>,
    icon: <Icon38 />,
  },
  {
    content: <Trans>SlideTilesContent1_3</Trans>,
    icon: <Icon39 />,
  },
  {
    content: <Trans>SlideTilesContent1_4</Trans>,
    icon: <Icon40 />,
  },
  {
    content: <Trans>SlideTilesContent1_5</Trans>,
    icon: <Icon41 />,
  },

  {
    content: <Trans>SlideTilesContent1_6</Trans>,
    icon: <Icon42 />,
  },
  {
    content: <Trans>SlideTilesContent1_7</Trans>,
    icon: <Icon13 />,
  },
]
const SlideTiles2 = [
  {
    content: <Trans>SlideTilesContent2_1</Trans>,
    icon: <Icon44 />,
  },
  {
    content: <Trans>SlideTilesContent2_2</Trans>,
    icon: <Icon45 />,
  },
  {
    content: <Trans>SlideTilesContent2_3</Trans>,
    icon: <Icon37 />,
  },
  {
    content: <Trans>SlideTilesContent2_4</Trans>,
    icon: <Icon46 />,
  },
  {
    content: <Trans>SlideTilesContent2_5</Trans>,
    icon: <Icon47 />,
  },
]

const SlideTiles3 = [
  {
    content: <Trans>SlideTilesContent3_1</Trans>,
    icon: <Icon33 />,
  },
  {
    content: <Trans>SlideTilesContent3_2</Trans>,
    icon: <Icon32 />,
  },
  {
    content: <Trans>SlideTilesContent3_3</Trans>,
    icon: <Icon48 />,
  },
  {
    content: <Trans>SlideTilesContent3_4</Trans>,
    icon: <Icon37 />,
  },

  {
    content: <Trans>SlideTilesContent3_5</Trans>,
    icon: <Icon27 />,
  },
  {
    content: <Trans>SlideTilesContent3_6</Trans>,
    icon: <Icon13 />,
  },
]

const vm_detector = () => {
  return (
    <>
      <ProductsHero
        id='VMDetectorHero'
        whereToScroll='VMDetectorScroll'
        title='VM Detector'
        heading='Safety first? Automate it with AI.'
        description='Vumo’s VM Detector is a groundbreaking AI-powered technology aimed at the safety of your workers. It makes your workplace a safer and happier place by reducing Occupational Health and Safety violations.'
        MHeroVideo={MHeroVideo}
        THeroVideo={THeroVideo}
        DHeroVideo={DHeroVideo}
        scrollBtnStyles='lg:block'
      />
      <SectionTextVideo
        scrollId='VMDetectorScroll'
        id='TextVideo1'
        styleList='bg-black-100 text-white'
        heading='Cameras and algorithms for a safer workplace'
        content='Workers’ behavior at factories and warehouses can be reckless. It doesn’t have to be that way. With the help of AI you can automatically enforce the proper conduct of the workforce and care for your workers’ safety. Vumo’s AI-powered computer vision system automatically signals any inappropriate behavior in terms of occupational health and safety and enables you to implement effective corrections.'
        videoM={MSplitVideo}
        videoT={TSplitVideo}
        videoD={DSplitVideo}
      />
      <div className='pt-[75px] lg:block hidden bg-gray-100'></div>

      <TilesSwiper2
        SlideTiles={SlideTiles1}
        TileStyle='min-h-[160px] justify-center '
        GridStyles='lg:grid-cols-[repeat(4,_minmax(0,_1fr))] lg:gap-[17px]  grid-cols-2 auto-rows-fr gap-[15px]'
        heading={<Trans>SectionTilesSwiperHeading1</Trans>}
      />
      <TilesSwiper2
        SlideTiles={SlideTiles2}
        TileStyle='min-h-[160px] justify-center '
        GridStyles='lg:grid-cols-[repeat(5,_minmax(0,_1fr))] lg:gap-[17px]  grid-cols-2 auto-rows-fr gap-[15px]'
        heading={<Trans>SectionTilesSwiperHeading2</Trans>}
      />
      <TilesSwiper2
        SlideTiles={SlideTiles3}
        TileStyle='min-h-[160px] justify-center '
        GridStyles='lg:grid-cols-[repeat(3,_minmax(0,_1fr))] lg:gap-[17px]  grid-cols-2 auto-rows-fr gap-[15px]'
        heading={<Trans>SectionTilesSwiperHeading3</Trans>}
      />

      <SectionBigTile
        containerStyle=' pb-[25px] md:pb-[125px] lg:pt-[80px] '
        heading={<Trans>SectionBigTileHeading</Trans>}
        content={<Trans>SectionBigTileContent</Trans>}
        icon1={<Icon41 />}
        icon2={<Icon49 />}
        icon3={<Icon13 />}
      />
      <SectionTechnology
        id='sectionTechnology'
        heading={<Trans>SectionTechnologyHeading</Trans>}
        content={<Trans>SectionTechnologyContent</Trans>}
      />

      <SectionOrder
        heading={<Trans>SectionOrderHeading</Trans>}
        link='/contact'
        content={<Trans>SectionOrderContent</Trans>}
      />

      <SelectedProducts
        title={<Trans>SelectedProductsTitle</Trans>}
        end={<Trans>SelectedProductsEnd</Trans>}
        slug='/vm-detector'
      />
    </>
  )
}

export const Head = () => (
  <Seo
    title='Violations monitoring detecor | Vumo.ai'
    description='Automate and manage safety, risk and compliance processes with ease. Our system will help You detect all exeptions from You Healt & Safety rules.'
  />
)

export default vm_detector

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: { language: { eq: $language }, ns: { eq: "vm_detector" } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
